import testReducer from "../reducers/test";
import { TEST } from "../actions/types";
import { flattenTasks } from "../utills/logicUtils";
import { TASK_TYPES, YESNO, DEVICE_TYPE } from "../actions/constants";

export const usePreviousTaskUrlMiddleware = (store) => (next) => (action) => {
  if (action.type === TEST.UPDATE) {
    const clonedState = { ...store.getState().test };
    const updatedState = testReducer(clonedState, action);

    const { test, tasks = [] } = updatedState?.data || {};

    // Disable next condition if test is for "Mobile" or "Tablet" device
    if (Number(test?.testing_device) !== DEVICE_TYPE.COMPUTER) return next(action);

    // Fetch invalid task id for use previous task url
    const obj = getInvalidIdObjForUsePreTask(tasks);

    if (!obj?.inValidId) return next(action);
    else {
      store.dispatch({
        type: TEST.SHOW_UPDATE_CONFIRMATION_MODAL,
        payload: {
          show: true,
          errorMessage: "",
          confirmationFor: TEST.CONFIRMATION_FOR.TASK_USEPRETASKURL,
          onProceed: () => {
            // Get invalid task id for use previous task url
            const obj = getInvalidIdObjForUsePreTask(tasks);

            const getTask = (task) => {
              const usePrevEnabled = Number(task?.use_prevtask_url) === YESNO.YES;
              return {
                ...task,
                url: usePrevEnabled ? "" : task?.url,
                use_prevtask_url: task?.id === obj?.inValidId ? false : task?.use_prevtask_url,
              };
            };

            const updatedTasks = tasks.map((task) => ({ ...getTask(task), subTasks: task?.subTasks?.map(getTask) || [] }));

            store.dispatch({ type: TEST.UPDATE, payload: { data: { ...updatedState?.data, tasks: updatedTasks } } });
          },
          onCancel: () => {
            store.dispatch({
              type: TEST.UPDATE,
              payload: {
                ...clonedState,
                data: { ...clonedState?.data, tasks: clonedState?.data?.tasks.filter((task) => task?.type !== TASK_TYPES.EMPTY) },
              },
            });
          },
        },
      });
    }
  }

  return next(action);
};

// Get invalid task id for use previous task url
function getInvalidIdObjForUsePreTask(tasks) {
  return flattenTasks(tasks).reduce(
    (obj, task) => {
      if (obj?.inValidId) return obj;

      const isDefaultOrPrototypeTask = Number(task?.type) === TASK_TYPES.DEFAULT || Number(task?.type) === TASK_TYPES.EXTERNAL_PROTOTYPE;
      const usePrevtaskUrl = Number(task?.use_prevtask_url) === YESNO.YES;

      // Initiate check
      if (!obj?.initCheck && isDefaultOrPrototypeTask) return { ...obj, initCheck: true };

      // Remove hasInvalid flag if it has valid task
      if (obj?.initCheck && isDefaultOrPrototypeTask && !usePrevtaskUrl) return { ...obj, hasInvalid: false };

      // Add invalid task id if it has invalid task
      if (obj?.initCheck && isDefaultOrPrototypeTask && usePrevtaskUrl) {
        return { ...obj, inValidId: obj?.hasInvalid ? task?.id : obj?.inValidId };
      }

      // Add hasInvalid flag if it has invalid task
      if (obj?.initCheck && [TASK_TYPES.IMAGE, TASK_TYPES.BLANK].includes(Number(task?.type))) {
        return { ...obj, hasInvalid: true };
      }

      return obj;
    },
    { inValidId: null, initCheck: false, hasInvalid: false }
  );
}
